import './CalendarHeaderToggle.scss';
import { useTranslation } from 'react-i18next';


const CalendarHeaderToggle = ({onHandleChangeOfCalendar, stripView}) => {
    const { t } = useTranslation();

    return (
        <div className='c-toggle'>
            <span className='toggle__calendar'>
                {t('myBlockMonth.stripCalendarHeader.calendar')}
            </span>
            <span className='toggle__calendar-view'>
                {stripView ? t('myBlockMonth.stripCalendarHeader.stripView') : t('myBlockMonth.stripCalendarHeader.standardView')}
            </span>
            <div className='c-btn-toggle'>
                <button className='btn-toggle btn-toggle--strip selected' disabled={stripView} onClick={onHandleChangeOfCalendar}>
                    <i className={stripView ? 'calendar-icon-common-styles icon-Strip-Calendar-Icon calendar-icon-selected' : 'icon-Strip-Calendar-Icon calendar-icon-common-styles'}></i>
                </button>
                <button className='btn-toggle btn-toggle--standard selected' disabled={!stripView} onClick={onHandleChangeOfCalendar}>
                    <i className={!stripView ? 'icon-Calendar calendar-icon-common-styles calendar-icon-selected' : 'icon-Calendar calendar-icon-common-styles'}></i>
                </button>
            </div>
        </div>
    )
}

export default CalendarHeaderToggle;